import FeedbackForm from './containers/FeedbackFormView';

import React from 'react';

export {uiDataHelpFeedbackForm} from './reducers/FeedbackFormView';
export default FeedbackForm;
